export enum SortOrder {
  Asc = "Asc",
  Desc = "Desc"
}
